import { IconEdit, IconTrash } from "@tabler/icons-react";
import React from "react";
import { Button } from "react-bootstrap";

const WorkshopSupplierTable = ({ suppliers, onEdit, onDelete, Pagination }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-hover table-sm">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Contact Person</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Address</th>
            <th className="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          {suppliers.length > 0 ? (
            suppliers.map((supplier, index) => (
              <tr key={supplier.id}>
                <td>{index + 1}</td>
                <td>{supplier.name}</td>
                <td>{supplier.contact_person}</td>
                <td>{supplier.phone}</td>
                <td>{supplier.email}</td>
                <td>
                  <div style={{
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}>
                    {supplier.address}
                  </div>
                </td>
                <td className="text-end">
                  <Button
                    variant="warning"
                    size="sm"
                    className="me-2"
                    onClick={(e) => onEdit(e, supplier)}
                  >
                    <IconEdit size={18} /> Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => onDelete(supplier.id)}
                  >
                    <IconTrash size={18} /> Delete
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No suppliers available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="mt-4 text-center">{Pagination}</div>
    </div>
  );
};

export default WorkshopSupplierTable;
